import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { getCurrentUser } from '../../lib/auth';
export default function AdminGuard({ children }) {
  const [checking, setChecking] = useState(true);
  const [authorized, setAuthorized] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    async function check() {
      const user = await getCurrentUser();
      if (!user) { navigate('/'); return; }

      const { data: profile } = await supabase
        .from('user_profiles')
        .select('is_admin')
        .eq('user_id', user.id)
        .single();

      if (!profile?.is_admin) { navigate('/'); return; }

      setAuthorized(true);
      setChecking(false);
    }
    check();
  }, [navigate]);

  if (checking) return (
    <div style={{
      height: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: 'var(--brand-paper)',
      fontFamily: 'var(--font-body)', color: 'var(--neutral-500)', fontSize: 'var(--font-size-md)'
    }}>
      Checking access...
    </div>
  );

  if (!authorized) return null;
  return children;
}